<template>
    <div class="groupField">
        <div class="groupFieldTitle">
            <span>DNU list</span>
		        <v-btn
				        @click="onAddItem" type="button"
				        depressed
				        class="mainBtn mainBtn-text"
		        >
			        <span class="btnIco"><svg-sprite icon-id="addItem" width="20" height="20"></svg-sprite></span>
			        <span class="btnText">Add DNU</span>
		        </v-btn>
        </div>
        <template v-for="(item, idx) in dnuList">
            <div class="groupField_wrap" :key="idx">
                <field
                    :classError="getError(idx)"
                    margin="0 0 10px 0"
                    width="100%"
                    label="Broker name"
                    placeholder="Select broker name"
                    @updateAutocomplete="onAutocomplete($event)"
                    :autocompleteValue="item"
                    :items="brokers"
                    :idx="idx"
                    :isClearable="false"
                    is-required
                    is-autocomplete
                ></field>
                <button type="button" class="deleteItem" @click="onDeleteItem(idx, 'dnuList')">
                    <svg-sprite style="color: #19BC38" width="20" height="20" icon-id="deleteItem"></svg-sprite>
                </button>
            </div>
        </template>
    </div>
</template>

<script>
export default {
	name: "Dnu",
	props: {
		valid: Object,
		brokers: Array,
		dnu: Array
	},
	data: () => ({
		dnuList: []
	}),
	methods: {
		getError(idx) {
			return this.valid.dnu?.$each?.$iter[idx]?.broker_id?.$error;
		},
		onAddItem() {
			const value = {
				broker_id: null,
				id: null,
				value: null,
				status: 1
			};

			this.dnuList.push(value);
			this.getData();
		},
		onAutocomplete({ value, idx }) {
			let item = this.dnuList.find((item, index) => index === idx);
			if (item.status) {
				item = { ...item, ...value };
			} else {
				item = value;
			}
			this.dnuList.splice(idx, 1, item);
			this.getData();
		},
		onDeleteItem(idx, key) {
			this[key].splice(idx, 1);
			this.getData();
		},
		getData() {
			this.$emit('updateDnuList', this.dnuList);
		},
	},
	mounted() {
		this.dnuList = this.dnu;
	}
};
</script>

<style scoped lang="scss">
@import "Dnu";
</style>
